import DemoVaspsTable from './DemoVaspsTable'

export default DemoVaspsTable
